<template>
  <div class="shareGuide" v-show="showShareGuide">
    <div class="shareGuide-mask"></div>
    <div class="shareGuide-text"></div>
  </div>
</template>

<script>
export default {
  name: 'shareGuide',
  data() {
    return {
      showShareGuide: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';

.shareGuide-mask {
  @include set-image('../assets/images/mask.png');
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
}
.shareGuide-text {
  @include set-image('../assets/images/home-share-text.png');
  @include set-size(372, 112);
  position: fixed;
  @include set-property(top, 122);
  @include set-property(left, 325);
  z-index: 100;
}
</style>
